import React from 'react';
import { useTranslation } from 'react-i18next';

import { IngestionSourceParametersType, IngestionVolumeInfo } from '../../../../../../gamma-api';
import { formatFileCount, formatFileSize } from '../../../../../utils/fileUtil';
import { EMPTY_VALUE } from '../../../../../utils/stringUtil';

import './index.less';
import { MAIN_CLASS_NAME } from './const';

export interface ISourceVolumeProps {
  type: IngestionSourceParametersType;
  value?: IngestionVolumeInfo;
}

const SourceVolume: React.FC<ISourceVolumeProps> = ({ type, value }) => {
  const { t } = useTranslation();

  const getText = () => {
    if (!value) {
      return EMPTY_VALUE;
    }

    if (
      type === IngestionSourceParametersType.WebsiteUrls ||
      type === IngestionSourceParametersType.WebsiteCrawler ||
      type === IngestionSourceParametersType.Website
    ) {
      return t('Source volume: Website', {
        pageCount: formatFileCount(value.resource_count || 0),
        tokenCount: formatFileCount(value.token_count || 0),
      });
    }

    if (type === IngestionSourceParametersType.File) {
      return t('Source volume: File', {
        fileCount: formatFileCount(value.resource_count || 0),
        fileSize: formatFileSize(value.content_size || 0),
        tokenCount: formatFileCount(value.token_count || 0),
      });
    }

    if (type === IngestionSourceParametersType.Elma365) {
      return t('Source volume: ELMA365', {
        elementCount: formatFileCount(value.resource_count || 0),
        tokenCount: formatFileCount(value.token_count || 0),
      });
    }

    if (type === IngestionSourceParametersType.Confluence) {
      return t('Source volume: Confluence', {
        pageCount: formatFileCount(value.resource_count || 0),
        tokenCount: formatFileCount(value.token_count || 0),
      });
    }

    return t('Source volume: All', {
      resource_count: formatFileCount(value.resource_count || 0),
      documentCount: formatFileCount(value.document_count || 0),
      articleCount: formatFileCount(value.article_count || 0),
      fragmentCount: formatFileCount(value.fragment_count || 0),
      embeddingCount: formatFileCount(value.embedding_count || 0),
      contentSize: formatFileSize(value.content_size || 0),
      symbolCount: formatFileCount(value.symbol_count || 0),
      tokenCount: formatFileCount(value.token_count || 0),
      vectorSize: formatFileSize(value.vector_size || 0),
      nodeCount: formatFileCount(value.node_count || 0),
    });
  };

  return <span className={MAIN_CLASS_NAME}>{getText()}</span>;
};

export default SourceVolume;
